import React from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Button, ButtonProps } from '@mui/material';

import { changesExist, getLayoutModelsWithPendingChanges } from '@paragon/layout-models';
import { OptionalTooltip } from '@paragon/material';

import { openProject } from '../../store/actions/projects';
import { useAppDispatch, useAppSelector } from '../hooks';

export function DesignProjectButton({
  projectGuid,
  size,
  sx,
}: {
  readonly projectGuid: string;
  readonly size?: ButtonProps['size'];
  readonly sx?: ButtonProps['sx'];
}) {
  const dispatch = useAppDispatch();
  const projectChangesExist = useAppSelector(changesExist);
  const projectExists = useAppSelector((state) => projectGuid in getLayoutModelsWithPendingChanges(state));

  let disabledReason = '';

  if (projectChangesExist) {
    disabledReason = 'Save your changes before designing a project';
  }

  if (!projectExists) {
    disabledReason = 'Project is still loading';
  }

  const disabled = !!disabledReason;

  const button = (
    <Button
      variant="contained"
      color="designPrimary"
      size={size}
      sx={sx}
      startIcon={<OpenInNewIcon />}
      onClick={(event) => {
        if (event.detail > 0) event.currentTarget.blur();
        dispatch(openProject(projectGuid));
      }}
      disabled={disabled}
    >
      Design
    </Button>
  );

  return (
    <Box component="span" sx={{ display: 'inline-flex' }} onClick={(event) => event.stopPropagation()}>
      {disabled ? (
        <OptionalTooltip arrow disableInteractive visible title={disabledReason}>
          {button}
        </OptionalTooltip>
      ) : (
        button
      )}
    </Box>
  );
}
